/* RAKNIDA — Sell · Apply (DEC-444, 13 Oct 2026). Replaces rk-sell-upload.js on /pages/sell.
   ───────────────────────────────────────────────────────────────────────
   The application is the first test of fit, so the form tells the artist, as
   they go, what the curators will see:

   · WORKS — 3 to 5, JPG/PNG, ≤20 MB. Each file is decoded in the browser and
     read back as pixels, nearest standard ratio and the print sizes / editions
     it supports, using the register §5 floors (passed in data-rk-floors, the
     only copy). DEC-351: a size is offered when it or a larger size in the
     tier window passes. Studio floor 2,800 px (DEC-348) — below it we WARN,
     never block (Anth, 13 Oct): curators can still judge the art.
   · AI — the first 512 KB of each file is scanned for IPTC digitalSourceType /
     generator names (DEC-209). A hit is a prompt to declare, never a verdict;
     absence proves nothing.
   · TRADITION — type-ahead fed ONLY by the Studio vocabulary at <api>/cultures
     (§1.2, DEC-226: the form defines no heritage list). If that endpoint is not
     there yet, the field is plain text and curation maps the artist's wording.

   Upload path unchanged from rk-sell-upload.js: stage → POST binary → register
   through the Studio app proxy; the email carries names, the app gets ids. The
   record goes to <api>/submit first; the email is sent whatever happens there. */
(function () {
  var MAX_BYTES = 20 * 1024 * 1024;
  var RATIOS = [['4:5', 0.8], ['2:3', 2 / 3], ['3:4', 0.75], ['1:1', 1]];
  var SNIFF_BYTES = 512 * 1024;
  var AI_RE = /trainedAlgorithmicMedia|compositeWithTrainedAlgorithmicMedia|algorithmicMedia|midjourney|dall[·\-\s]?e|stable[\s_-]?diffusion|adobe firefly|imagen|ideogram/i;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function fmt(n) { return Number(n).toLocaleString('en-US'); }
  function tpl(s, o) { return String(s || '').replace(/\[(\w+)\]/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }
  function json(el, attr) { try { return JSON.parse(el.getAttribute(attr) || '{}'); } catch (e) { return {}; } }

  /* ── Print-fit: what a file of w×h supports (register §5) ─────────────── */
  function fit(w, h, F) {
    var long = Math.max(w, h), short = Math.min(w, h), r = short / long;
    var best = RATIOS[0], diff = 9;
    RATIOS.forEach(function (x) { var d = Math.abs(r - x[1]) / x[1]; if (d < diff) { diff = d; best = x; } });
    var ratio = best[0];
    var pass = function (sz) { return long >= F[sz][ratio]; };
    var studio = [];
    if (long >= (F.studioFloor || 2800)) {
      if (pass('L')) studio = ['S', 'M', 'L'];
      else if (pass('M')) studio = ['S', 'M'];
      else studio = ['S'];
    }
    var coll = [];
    if (pass('L')) { coll = ['M', 'L']; if (pass('XL')) coll.push('XL'); }
    var level = coll.length ? (coll.length === 3 ? 3 : 2) : (studio.length ? 1 : 0);
    return { w: w, h: h, long: long, ratio: ratio, uneven: diff > 0.05, studio: studio, coll: coll, level: level,
             needL: F.L[ratio], needXL: F.XL[ratio] };
  }

  function dims(file) {
    return new Promise(function (res) {
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () { res({ w: img.naturalWidth, h: img.naturalHeight, url: url }); };
      img.onerror = function () { res({ w: 0, h: 0, url: url }); };
      img.src = url;
    });
  }

  function sniffAI(file) {
    return new Promise(function (res) {
      try {
        var fr = new FileReader();
        fr.onload = function () {
          var txt = '';
          try { txt = new TextDecoder('latin1').decode(new Uint8Array(fr.result)); } catch (e) { txt = ''; }
          res({ ai: AI_RE.test(txt), c2pa: /c2pa/i.test(txt) });
        };
        fr.onerror = function () { res({ ai: false, c2pa: false }); };
        fr.readAsArrayBuffer(file.slice(0, SNIFF_BYTES));
      } catch (e) { res({ ai: false, c2pa: false }); }
    });
  }

  /* ── Countries: names from the browser, no list shipped ─────────────── */
  var CODES = 'AF AL DZ AD AO AG AR AM AU AT AZ BS BH BD BB BY BE BZ BJ BT BO BA BW BR BN BG BF BI CV KH CM CA CF TD CL CN CO KM CG CD CR CI HR CU CY CZ DK DJ DM DO EC EG SV GQ ER EE SZ ET FJ FI FR GA GM GE DE GH GR GD GT GN GW GY HT HN HK HU IS IN ID IR IQ IE IL IT JM JP JO KZ KE KI KW KG LA LV LB LS LR LY LI LT LU MO MG MW MY MV ML MT MH MR MU MX FM MD MC MN ME MA MZ MM NA NR NP NL NZ NI NE NG KP MK NO OM PK PW PS PA PG PY PE PH PL PT PR QA RO RU RW KN LC VC WS SM ST SA SN RS SC SL SG SK SI SB SO ZA KR SS ES LK SD SR SE CH SY TW TJ TZ TH TL TG TO TT TN TR TM TV UG UA AE GB US UY UZ VU VA VE VN YE ZM ZW GP MQ GF RE YT CW AW BM KY VG VI TC';
  function countries(list) {
    if (!list || typeof Intl === 'undefined' || !Intl.DisplayNames) return;
    var dn; try { dn = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (e) { return; }
    CODES.split(' ').map(function (c) { try { return dn.of(c); } catch (e) { return ''; } })
      .filter(Boolean).sort().forEach(function (n) { var o = document.createElement('option'); o.value = n; list.appendChild(o); });
  }

  /* ── Tradition type-ahead (Studio vocabulary only) ──────────────────── */
  function tradition(root, form, M) {
    var input = root.querySelector('[data-rk-trad-input]');
    var list = input && document.getElementById(input.getAttribute('list'));
    var listed = root.querySelector('[data-rk-trad-listed]');
    var status = root.querySelector('[data-rk-trad-status]');
    var none = root.querySelector('[data-rk-trad-none]');
    var rel = form.querySelector('[data-rk-rel]');
    var deps = form.querySelectorAll('[data-rk-trad-dependent]');
    var helpText = status ? status.textContent : '';
    var vocab = null;   /* [{name, keys:[lowercased name + aliases]}] */

    fetch((root.getAttribute('data-rk-api') || '/apps/studio/api/apply') + '/cultures', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (j) {
        var arr = Array.isArray(j) ? j : (j.cultures || []);
        vocab = arr.map(function (c) {
          var name = typeof c === 'string' ? c : (c.name || c.label || '');
          var al = (c && c.aliases) || [];
          return { name: name, keys: [name].concat(al).map(function (k) { return String(k).toLowerCase().trim(); }) };
        }).filter(function (c) { return c.name; });
        if (list) vocab.forEach(function (c) { var o = document.createElement('option'); o.value = c.name; list.appendChild(o); });
        check();
      })
      .catch(function () { vocab = null; if (listed) listed.value = 'Not checked — vocabulary unavailable'; });

    function check() {
      if (!input || !listed) return;
      var v = input.value.trim();
      if (!v) { listed.value = vocab ? 'No' : 'Not checked — vocabulary unavailable'; if (status) status.textContent = helpText; return; }
      if (!vocab) return;
      var lv = v.toLowerCase(), hit = null;
      vocab.some(function (c) { if (c.keys.indexOf(lv) > -1) { hit = c; return true; } return false; });
      listed.value = hit ? 'Yes — ' + hit.name : 'No — propose to curation';
      if (status) status.textContent = hit ? M.listed : M.unlisted;
    }
    if (input) { input.addEventListener('change', check); input.addEventListener('blur', check); }

    function setNone() {
      var on = none && none.checked;
      if (input) { input.disabled = on; if (on) input.value = ''; }
      each(deps, function (d) { d.classList.toggle('is-off', !!on); each(d.querySelectorAll('input,select'), function (x) { x.disabled = !!on; }); });
      if (rel) rel.required = !on;
      if (status) status.textContent = on ? '' : helpText;
      if (listed) listed.value = on ? 'Not applicable' : listed.value;
    }
    if (none) none.addEventListener('change', setNone);

    return function valid() {
      return (none && none.checked) || (input && input.value.trim().length > 1);
    };
  }

  /* ── Works upload ────────────────────────────────────────────────────── */
  function uploader(root, form, M, aiDeclared) {
    var api = root.getAttribute('data-rk-api') || '/apps/studio/api/apply';
    var F = json(root, 'data-rk-floors');
    var MIN = +root.getAttribute('data-rk-min') || 3, MAX = +root.getAttribute('data-rk-max') || 5;
    var input = root.querySelector('[data-rk-upload-input]');
    var zone = root.querySelector('[data-rk-dropzone]');
    var listEl = root.querySelector('[data-rk-upload-list]');
    var errEl = root.querySelector('[data-rk-upload-err]');
    var countEl = root.querySelector('[data-rk-upload-count]');
    var sumEl = root.querySelector('[data-rk-upload-summary]');
    var field = root.querySelector('[data-rk-upload-field]');
    var checkField = root.querySelector('[data-rk-upload-check]');
    if (!input || !zone || !field) return null;

    var items = [], busy = false, batch = '', failed = false;
    input.hidden = false; zone.hidden = false;
    var fb = root.querySelector('[data-rk-upload-fallback]'); if (fb) fb.hidden = true;

    function say(m) { if (errEl) { errEl.textContent = m || ''; errEl.hidden = !m; } }

    function readout(it) {
      var f = it.fit;
      if (!f || !f.long) return { cls: 'warn', text: 'Could not read this image’s size.' };
      if (f.level === 0) return { cls: 'warn', text: M.low };
      if (f.level === 1) return { cls: 'mid', text: tpl(M.studioOnly, { sizes: f.studio.join(' · '), px: fmt(f.needL) }) };
      var t = tpl(M.collector, { sizes: f.coll.join(' · '), studio: f.studio.join(' · ') });
      if (f.level === 2) t += ' ' + tpl(M.xl, { px: fmt(f.needXL) });
      return { cls: 'ok', text: t };
    }

    function render() {
      var n = items.length;
      listEl.hidden = n === 0; listEl.textContent = '';
      items.forEach(function (it, i) {
        var li = document.createElement('li');
        var img = document.createElement(it.url ? 'img' : 'span');
        img.className = 'rk-sell-upload-thumb'; if (it.url) { img.src = it.url; img.alt = ''; }
        li.appendChild(img);

        var meta = document.createElement('span'); meta.className = 'rk-sa-meta';
        var nm = document.createElement('span'); nm.className = 'rk-sell-upload-name'; nm.textContent = it.name; meta.appendChild(nm);
        if (it.fit) {
          var d = document.createElement('span'); d.className = 'rk-sa-dims';
          d.textContent = it.fit.long ? fmt(it.fit.w) + ' × ' + fmt(it.fit.h) + ' px · ' + it.fit.ratio + (it.fit.uneven ? ' (nearest)' : '') + ' · ' + (it.size / 1048576).toFixed(1) + ' MB' : '';
          meta.appendChild(d);
          var r = readout(it), b = document.createElement('span');
          b.className = 'rk-sa-fit ' + r.cls; b.textContent = r.text; meta.appendChild(b);
          if (it.fit.uneven) { var u = document.createElement('span'); u.className = 'rk-sa-fit mid'; u.textContent = M.even; meta.appendChild(u); }
          if (it.ai && !aiDeclared()) { var a = document.createElement('span'); a.className = 'rk-sa-fit mid'; a.textContent = M.ai; meta.appendChild(a); }
        }
        li.appendChild(meta);

        var st = document.createElement('span');
        st.className = 'rk-sell-upload-state' + (it.state === 'done' ? ' ok' : it.state === 'bad' ? ' bad' : '');
        st.textContent = it.state === 'done' ? M.uploaded : it.state === 'bad' ? M.fail : it.state === 'up' ? M.uploading : M.waiting;
        li.appendChild(st);

        if (!busy) {
          var rm = document.createElement('button');
          rm.type = 'button'; rm.className = 'rk-sell-upload-remove'; rm.textContent = M.remove;
          rm.setAttribute('aria-label', M.remove + ' ' + it.name);
          rm.addEventListener('click', function () {
            if (items[i] && items[i].local) { try { URL.revokeObjectURL(items[i].local); } catch (e) {} }
            items.splice(i, 1); sync(); render();
          });
          li.appendChild(rm);
        }
        listEl.appendChild(li);
      });

      var done = items.filter(function (x) { return x.state === 'done'; }).length;
      if (countEl) {
        countEl.hidden = n === 0;
        countEl.textContent = done + ' of ' + MIN + '–' + MAX + ' works uploaded';
        countEl.className = 'rk-sa-count ' + (done >= MIN ? 'is-ok' : 'is-short');
      }
      if (done >= MIN) { var fe = form.querySelector('[data-rk-form-err]'); if (fe && !fe.hidden && /\b3\b|works/.test(fe.textContent)) { fe.textContent = ''; fe.hidden = true; } }
      if (sumEl) {
        var c = [0, 0, 0];
        items.forEach(function (x) { if (x.fit) c[x.fit.level >= 2 ? 0 : x.fit.level === 1 ? 1 : 2]++; });
        var parts = [];
        if (c[0]) parts.push(c[0] + ' Collector/Limited-ready');
        if (c[1]) parts.push(c[1] + ' Studio only');
        if (c[2]) parts.push(c[2] + ' below the size needed');
        sumEl.hidden = !parts.length;
        sumEl.textContent = tpl(M.weakest, { tiers: parts.join(' · ') });
      }
    }

    function sync() {
      var done = items.filter(function (x) { return x.state === 'done'; });
      var lines = done.map(function (x) { return '· ' + (x.stored || x.name) + (x.url && x.url.indexOf('blob:') !== 0 ? '  ' + x.url : ''); });
      if (batch && done.length) { lines.push(''); lines.push('Find these in Shopify admin → Content → Files, search: ' + batch); }
      field.value = lines.join('\n');
      if (checkField) {
        checkField.value = items.map(function (x) {
          var f = x.fit; if (!f || !f.long) return '· ' + x.name + ' — size unreadable';
          var lv = ['BELOW 2,800 px', 'Studio only', 'Collector/Limited (no XL)', 'Collector/Limited incl. XL'][f.level];
          return '· ' + x.name + ' — ' + f.w + '×' + f.h + ' px, ' + f.ratio + (f.uneven ? ' (nearest)' : '') +
            ', ' + lv + (x.ai ? ', AI metadata found' : '') + (x.c2pa ? ', Content Credentials present' : '');
        }).join('\n');
      }
    }

    function post(path, body) {
      return fetch(api + '/' + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.message || j.error || ('http_' + r.status)); return j; }); });
    }

    function setBusy(v) {
      busy = v; zone.classList.toggle('is-busy', v);
      var b = form.querySelector('[type="submit"]'); if (b) b.disabled = v;
    }

    function add(files) {
      say('');
      var picked = [], msg = '';
      each(files, function (f) {
        if (items.length + picked.length >= MAX) { msg = M.max; return; }
        if (!/^image\/(jpeg|png)$/.test(f.type)) { msg = tpl(M.type, { f: f.name }); return; }
        if (f.size > MAX_BYTES) { msg = tpl(M.big, { f: f.name }); return; }
        picked.push(f);
      });
      if (msg) say(msg);
      if (!picked.length) return;
      var start = items.length;
      picked.forEach(function (f) { items.push({ name: f.name, size: f.size, state: 'pending', url: '', local: '' }); });
      setBusy(true); render();
      /* Measure first (fast, local), then upload. Low files still go up — warn, never block. */
      Promise.all(picked.map(function (f, i) {
        return Promise.all([dims(f), sniffAI(f)]).then(function (r) {
          var it = items[start + i]; if (!it) return;
          it.url = it.local = r[0].url; it.fit = fit(r[0].w, r[0].h, F); it.ai = r[1].ai; it.c2pa = r[1].c2pa;
        });
      })).then(function () { sync(); render(); upload(picked, start); });
    }

    function upload(files, start) {
      post('stage', { files: files.map(function (f) { return { filename: f.name, mimeType: f.type, fileSize: f.size }; }) })
        .then(function (res) {
          var targets = res.targets || [];
          batch = res.prefix || batch;
          (res.filenames || []).forEach(function (n, i) { if (items[start + i]) items[start + i].stored = n; });
          return files.reduce(function (chain, f, i) {
            return chain.then(function () {
              var t = targets[i]; if (!t) throw new Error('stage_missing');
              items[start + i].state = 'up'; render();
              var fd = new FormData();
              (t.parameters || []).forEach(function (p) { fd.append(p.name, p.value); });
              fd.append('file', f);
              return fetch(t.url, { method: 'POST', body: fd }).then(function (r) { if (!r.ok) throw new Error('transfer_failed'); items[start + i].resourceUrl = t.resourceUrl; });
            });
          }, Promise.resolve()).then(function () {
            return post('register', { resourceUrls: files.map(function (_, i) { return items[start + i].resourceUrl; }) });
          });
        })
        .then(function (res) {
          (res.files || []).forEach(function (f, i) { var it = items[start + i]; if (!it) return; it.state = 'done'; it.id = f.id || ''; if (f.url) it.url = f.url; });
          sync(); setBusy(false); render();
        })
        .catch(function () {
          failed = true;
          for (var i = start; i < items.length; i++) if (items[i].state !== 'done') items[i].state = 'bad';
          say(M.failed); sync(); setBusy(false); render();
        });
    }

    input.addEventListener('change', function () { add(input.files); input.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) { zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.add('is-drag'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.remove('is-drag'); }); });
    zone.addEventListener('drop', function (e) { if (!busy && e.dataTransfer && e.dataTransfer.files) add(e.dataTransfer.files); });
    zone.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); } });

    return {
      busy: function () { return busy; },
      failed: function () { return failed; },
      done: function () { return items.filter(function (x) { return x.state === 'done'; }); },
      all: function () { return items; },
      batch: function () { return batch; },
      rerender: render,
      say: say, min: MIN
    };
  }

  /* ── Form ────────────────────────────────────────────────────────────── */
  function init(form) {
    var up = form.querySelector('[data-rk-apply-upload]');
    var M = up ? json(up, 'data-rk-msgs') : {};
    var formErr = form.querySelector('[data-rk-form-err]');
    function err(m, focusEl) {
      if (formErr) { formErr.textContent = m || ''; formErr.hidden = !m; }
      if (m && focusEl) { try { focusEl.focus({ preventScroll: false }); focusEl.scrollIntoView({ block: 'center' }); } catch (e) {} }
    }

    countries(form.querySelector('[data-rk-country]') && document.getElementById(form.querySelector('[data-rk-country]').getAttribute('list')));

    var tradRoot = form.querySelector('[data-rk-tradition]');
    var tradValid = tradRoot ? tradition(tradRoot, form, M) : function () { return true; };

    var methods = form.querySelectorAll('[data-rk-method]');
    function methodList() { var o = []; each(methods, function (m) { if (m.checked) o.push(m.getAttribute('data-rk-method')); }); return o; }
    function aiDeclared() { return methodList().some(function (k) { return /^ai/.test(k); }); }

    var U = up ? uploader(up, form, M, aiDeclared) : null;
    each(methods, function (m) { m.addEventListener('change', function () { if (U) U.rerender(); }); });

    each(form.querySelectorAll('[data-rk-count]'), function (ta) {
      var out = ta.parentNode.querySelector('[data-rk-count-out]');
      var max = +ta.getAttribute('maxlength') || 0;
      var upd = function () { if (out) out.textContent = '· ' + fmt(max - ta.value.length) + ' left'; };
      ta.addEventListener('input', upd); upd();
    });

    var recorded = false;
    form.addEventListener('submit', function (e) {
      if (recorded) return;
      e.preventDefault(); err('');
      if (U && U.busy()) { err(M.busy); return; }
      if (!form.reportValidity()) return;
      if (!tradValid()) { err(M.tradition, form.querySelector('[data-rk-trad-input]')); return; }
      if (methods.length && !methodList().length) { err(M.method, methods[0]); return; }
      var portfolio = (form.querySelector('[name="contact[Portfolio link]"]') || {}).value || '';
      if (U && U.done().length < U.min && !(U.failed() && portfolio)) {
        err(tpl(M.min, { n: U.done().length }), up.querySelector('[data-rk-dropzone]')); return;
      }
      recorded = true;

      var val = function (n) { var el = form.querySelector('[name="contact[' + n + ']"]'); return el && !el.disabled ? (el.type === 'checkbox' ? (el.checked ? el.value : '') : el.value) : ''; };
      var done = U ? U.done() : [];
      var all = U ? U.all() : [];
      var payload = {
        /* v1 keys, kept so the Studio queue keeps working before it is updated */
        email: val('email'), firstName: val('First name'), lastName: val('Last name'),
        heritage: val('The story'), aboutWork: val('About your practice'),
        portfolio: portfolio, social: val('Social link'), heard: val('How heard'),
        filePrefix: U ? U.batch() : '',
        fileNames: done.map(function (i) { return i.stored || i.name; }).join('\n'),
        fileGids: done.map(function (i) { return i.id || ''; }).join('\n'),
        /* v2 (DEC-444) */
        formVersion: 2,
        country: val('Country'), whatsapp: val('WhatsApp'),
        tradition: val('Tradition'), traditionListed: val('Tradition in culture list'),
        noTradition: !!val('Draws on no single tradition'),
        otherTraditions: val('Other traditions'),
        traditionRelationship: val('How they came to it') || (val('Draws on no single tradition') ? 'Not applicable' : ''),
        methods: methodList(),
        story: val('The story'),
        declaration: !!val('Declaration'),
        files: all.map(function (x) {
          var f = x.fit || {};
          return { name: x.stored || x.name, gid: x.id || '', state: x.state, bytes: x.size, width: f.w || 0, height: f.h || 0,
                   ratio: f.ratio || '', nearestRatio: !!f.uneven, studioSizes: f.studio || [], collectorSizes: f.coll || [],
                   belowFloor: f.level === 0, aiMetadata: !!x.ai, contentCredentials: !!x.c2pa };
        })
      };
      var go = function () { form.submit(); };
      var timer = setTimeout(go, 6000);
      fetch((up ? up.getAttribute('data-rk-api') : '/apps/studio/api/apply') + '/submit', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(payload)
      }).then(function () { clearTimeout(timer); go(); }).catch(function () { clearTimeout(timer); go(); });
    });
  }

  function boot() { each(document.querySelectorAll('form.rk-sa-form'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
